import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const listPaymentTerminals = async () => {
    const { data } = await axios.get(`${API}/payment-terminals`, { headers: authHeaders() });
    return data;
};

export const createPaymentTerminal = async (payload) => {
    const { data } = await axios.post(`${API}/payment-terminals`, payload, { headers: authHeaders() });
    return data;
};

export const updatePaymentTerminal = async (id, payload) => {
    const { data } = await axios.put(`${API}/payment-terminals/${id}`, payload, { headers: authHeaders() });
    return data;
};

export const deletePaymentTerminal = async (id) => {
    const { data } = await axios.delete(`${API}/payment-terminals/${id}`, { headers: authHeaders() });
    return data;
};
